import React, { FC } from 'react'

import { LoadingIcon, Txt } from 'src/components/atoms'

type Props = {
  className?: string
}

export const DeletingLabel: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <div className="tw-flex tw-items-center tw-text-errorRed-default">
        <Txt sizeType="s" className="tw-font-bold tw-mr-s-4">
          削除中
        </Txt>
        <LoadingIcon />
      </div>
    </div>
  )
}
